import { render, staticRenderFns } from "./recipe-question.vue?vue&type=template&id=76d33b44&scoped=true&"
import script from "./recipe-question.vue?vue&type=script&lang=js&"
export * from "./recipe-question.vue?vue&type=script&lang=js&"
import style0 from "./recipe-question.vue?vue&type=style&index=0&id=76d33b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d33b44",
  null
  
)

export default component.exports